import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useState } from 'react'
import * as S from './clickToCallEnergy.style';
import { callMeSchema } from './clickToCallEnergy.validation';
import { ICallMeBackSchema, IClickToCall } from './clickToCallEnergy.models';
import { ClickToCallCardSubmitted } from '../clickToCallEnergyCardSubmitted/clickToCallEnergyCardSubmitted';
import { ClickToCallCardToSubmit } from '../clickToCallEnergyToSubmit/clickToCallEnergyCardToSubmit';
import AppClickToCallChoice from '../AppClickToCallEnergyChoice/appClickToCallEnergyChoice';

const ClickToCall: React.FC<IClickToCall> = ({
  setTelephoneNumber,
  isSuccess,
  isLoading,
  isError,
  clickToCallData,
  defaultNumber,
  handleClose,
  isAppConfirmedActivation,
  onAppConfirmActivation,
  cmsAppClickToCallChoice,
  isSubmitted,
  cmsError,
}) => {
  const [submitted, setSubmitted] = useState(false);
  const [inputs, setInputs] = useState({});

  const form = useForm<ICallMeBackSchema>({
    resolver: yupResolver(callMeSchema()),
    mode: 'all',
  });

  const handleSubmit = () => {
    setInputs(form.getValues());
    setTelephoneNumber(form.getValues().phoneNumber);
    setSubmitted(true);
    isSubmitted?.(true);
  };

  if (submitted && isSuccess) {
    return (
      <S.ClickToCallCardFlow>
        <ClickToCallCardSubmitted
          clickToCallData={clickToCallData}
          phoneNumber={defaultNumber || (inputs as ICallMeBackSchema)?.phoneNumber}
        />
      </S.ClickToCallCardFlow>
    );
  }

  if ((defaultNumber && !submitted) || (defaultNumber && submitted && isLoading))
    return (
      <AppClickToCallChoice
        cmsAppClickToCallChoice={cmsAppClickToCallChoice}
        onActive={() => {
          onAppConfirmActivation?.();
          setSubmitted(true);
          isSubmitted?.(true);
        }}
        onClose={handleClose}
        isLoading={isLoading}
        isAppConfirmedActivation={isAppConfirmedActivation}
      />
    );

  if (isError) {
    return (
      <S.ClickToCallCardFlow>
        <ClickToCallCardSubmitted
          clickToCallData={clickToCallData}
          phoneNumber={defaultNumber || (inputs as ICallMeBackSchema)?.phoneNumber}
          isError
          cmsError={cmsError}
        />
      </S.ClickToCallCardFlow>
    );
  }

  return (
    <S.ClickToCallCardFlow>
      <ClickToCallCardToSubmit
        clickToCallData={clickToCallData}
        form={form}
        handleSubmit={handleSubmit}
        isLoading={isLoading}
      />
    </S.ClickToCallCardFlow>
  );
};

export default ClickToCall;
